<hard-modal
  [title]="'base.notifications' | hardTranslate"
  [subTitle]="'notification.subModalTitle' | hardTranslate"
  [icon]="'icon-notifications-none !text-[30px]'"
  [actions]="footer"
  (closeModal)="closeModal()"
>
  <div class="flex flex-col h-full overflow-hidden">
    <!-- Tabs Header -->
    <div
      class="flex items-center border-b border-[#e0e0e0] px-4 py-2 bg-white flex-shrink-0"
    >
      <div class="flex space-x-6">
        <button
          class="tab-btn pb-2 font-medium transition-colors border-b-2"
          [class.active-tab]="activeTab === 'all'"
          [class.border-transparent]="activeTab !== 'all'"
          (click)="switchTab('all')"
        >
          {{ "base.all" | hardTranslate }} ({{ allCount ?? 0 }})
        </button>
        <button
          class="tab-btn pb-2 font-medium transition-colors border-b-2"
          [class.active-tab]="activeTab === 'unread'"
          [class.border-transparent]="activeTab !== 'unread'"
          (click)="switchTab('unread')"
        >
          {{ "notification.notRead" | hardTranslate }}
          ({{ unreadCount ?? 0 }})
        </button>
      </div>

      <div class="flex-1"></div>

      @if (unreadCount > 0) {
        <button
          class="flex items-center text-gray-500 hover:text-gray-900 transition-colors"
          (click)="setAllNotificationAsRead()"
        >
          <span class="icon-double-checked mr-1 text-sm"></span>
          {{ "notification.markAllAsRead" | hardTranslate }}
        </button>
      }
    </div>

    <div class="flex-1 overflow-y-auto py-2">
      @if (loading) {
        <hard-loading />
      } @else {
        @if (notifications?.length > 0) {
          <div class="divide-y divide-[#e0e0e0]">
            @for (notification of notifications; track notification.id) {
              <div
                class="notification-item"
                [class.unread]="!notification.isRead"
                (click)="navigateToLink(notification)"
              >
                <div class="flex items-start justify-between">
                  <div class="flex items-center space-x-2">
                    <span
                      class="w-2 h-2 rounded-full flex-shrink-0"
                      [style.background-color]="
                        notification.isRead
                          ? 'var(--color-grey-300)'
                          : 'var(--color-success-main)'
                      "
                    ></span>
                    <span class="font-semibold text-sm text-gray-950">
                      {{ notification.title | hardTranslate }}
                    </span>
                  </div>
                  <span class="text-gray-400">
                    {{
                      notification.createdAt
                        | dateFormat: dateFormatEnum.DayMonthYearAndFullTime
                    }}
                  </span>
                </div>

                <!-- Second Row: Body/Details -->
                <div
                  class="mt-2 pl-4 text-gray-600 leading-relaxed whitespace-pre-line"
                >
                  {{ notification.body | hardTranslate }}
                </div>

                <!-- Third Row: Actions -->
                <div class="mt-3 pl-4 flex items-center justify-between">
                  @if (notification.linkUrl) {
                    <button
                      class="font-semibold text-[#0066b2] hover:text-[#00508c] transition-colors"
                      (click)="
                        navigateToLink(notification); $event.stopPropagation()
                      "
                    >
                      {{ "base.navigate" | hardTranslate }}
                    </button>
                  } @else {
                    <span></span>
                  }

                  @if (!notification.isRead) {
                    <button
                      class="flex items-center text-gray-500 hover:text-gray-800 transition-colors"
                      (click)="
                        setNotificationAsRead(notification.id);
                        $event.stopPropagation()
                      "
                    >
                      <span class="icon-done mr-1 text-sm"></span>
                      {{ "notification.markAsRead" | hardTranslate }}
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="h-full flex items-center justify-center">
            <hard-no-data />
          </div>
        }
      }
    </div>
  </div>
</hard-modal>

<ng-template #footer>
  @if (total > 0) {
    <div class="flex justify-end">
      <hard-paginator
        [index]="filter$.value.pageIndex"
        [size]="filter$.value.pageSize"
        [total]="total"
        [showPageSize]="true"
        (setIndex)="setPage($event)"
        (setSize)="setPageSize($event)"
      />
    </div>
  }
</ng-template>
